/**
 * Compute how many elements are considered answered on a step.
 *
 * Rules:
 * - Skipped items are counted as answered.
 * - The result is based on the index of the last answered element on the step (within the set of answerable elements).
 *
 * @param answered - Set of IDs for answered elements.
 * @param answerable - Set of IDs for answerable items and fields on the step.
 * @returns The number of answered elements, or 0 if none are answered.
 */
export function getNumberOfAnsweredElements(
  answered: Set<string>,
  answerable: Set<string>,
): number {
  let maxIndex: number = -1;
  let i: number = 0;

  for (const id of answerable) {
    if (answered.has(id)) {
      maxIndex = i;
    }
    i++
  }
  return maxIndex + 1;
}